import { useContext } from "react";
import { CustomerContext } from "../providers";

export function generateInitialNodesAndEdges(
  nodes,
  edges,
  setSelectedNodeId,
  readCount,
) {
  var initialNodes = [];
  var initialEdges = [];

  var nodeCounter = 1;
  var node;

  for (var k = 0; k < nodes.length; k++) {
    const dataNode = nodes[k];
    if (dataNode.type === "whatsapp_trigger") {
      node = {
        id: nodeCounter.toString(),
        type: "trigger",
        position: { x: dataNode.positionX, y: dataNode.positionY },
        deletable: false,
        data: {
          nodeId: dataNode.id,
          whatsappTriggerId: dataNode.whatsappTrigger.id,
          type: dataNode.whatsappTrigger.type,
          text: dataNode.whatsappTrigger.text,
          clickNode: setSelectedNodeId,
          disabled: (dataNode.whatsappTrigger.text ?? "") === "",
        },
      };
    } else if (dataNode.type === "message_skeleton") {
      const buttons = nodes.filter((n) => n?.parentNodeId === dataNode.id);
      const urlButton = dataNode.messageSkeleton?.urlButtonText
        ? {
            text: dataNode.messageSkeleton.urlButtonText,
            url:
              dataNode.messageSkeleton?.redirectionUrl?.url ||
              dataNode.messageSkeleton.urlButtonLink,
            redirectionUrlId: dataNode.messageSkeleton?.redirectionUrl?.id,
            trackingEnabled: dataNode.messageSkeleton?.redirectionUrl?.id
              ? true
              : false,
          }
        : null;
      const urlButton2 = dataNode.messageSkeleton?.urlButtonText2
        ? {
            text: dataNode.messageSkeleton.urlButtonText2,
            url: dataNode.messageSkeleton.urlButtonLink2,
            redirectionUrlId: dataNode.messageSkeleton?.redirectionUrl2?.id,
            trackingEnabled: dataNode.messageSkeleton?.redirectionUrl2?.id
              ? true
              : false,
          }
        : null;

      const {
        messageSkeleton,
        id: dataNodeId,
        positionX,
        positionY,
        replyButtons,
      } = dataNode;
      const {
        id,
        imageLink,
        audioLink,
        videoLink,
        documentLink,
        documentName,
        stickerLink,
        body,
        bodyParameters,
        header,
        footer,
        buttonTitle,
        isCampaignTrigger,
        whatsappTemplate,
        urlClicks,
      } = messageSkeleton;

      node = {
        id: nodeCounter.toString(),
        type: "message",
        position: { x: positionX, y: positionY },
        deletable: !isCampaignTrigger,
        data: {
          nodeId: dataNodeId,
          messageSkeletonId: id,
          isTemplate: isCampaignTrigger == true,
          type: buttonTitle
            ? "list"
            : body ||
                replyButtons ||
                imageLink ||
                audioLink ||
                videoLink ||
                documentLink
              ? "media"
              : stickerLink
                ? "sticker"
                : null,
          body: (body ?? "").replace(
            /{{\s*(\d+)\s*}}/g,
            (match, paramIndex) => {
              const index = parseInt(paramIndex, 10) - 1;
              const param = (bodyParameters ?? [])[index];
              return param ? `{{${param.selected}}}` : match;
            },
          ),
          bodyParameters,
          header: header ?? "",
          footer: footer ?? "",
          buttonTitle: buttonTitle ?? "",
          image: imageLink ?? "",
          video: videoLink ?? "",
          audio: audioLink ?? "",
          sticker: stickerLink ?? "",
          document: documentLink ?? "",
          documentName: documentName ?? "",
          buttons: buttons.map((b) =>
            b.type === "reply_button"
              ? {
                  title: b.replyButton?.title,
                  whatsappId: b.replyButton?.whatsappId,
                  gadgetId: b.id,
                  replyButtonGadgetId: b.replyButton?.id,
                  clicks: b.replyButton?.clicks,
                  clickRate: Math.min(
                    1,
                    b.replyButton?.clicks / Math.max(1, readCount),
                  ),
                }
              : {
                  title: b.replyList?.title,
                  description: b.replyList?.description ?? "",
                  whatsappId: b.replyList?.whatsappId,
                  gadgetId: b.id,
                  replyListGadgetId: b.replyList?.id,
                  clicks: b.replyList?.clicks,
                  clickRate: Math.min(
                    1,
                    b.replyList?.clicks / Math.max(1, readCount),
                  ),
                },
          ),
          urlButton: urlButton,
          urlButtonLink: urlButton?.url ?? null,
          urlButton2: urlButton2,
          urlClicks: whatsappTemplate?.urlClicks ?? urlClicks,
          urlClicks2: whatsappTemplate?.urlClicks2,
          urlClickRate: Math.min(
            1,
            (whatsappTemplate?.urlClicks ?? urlClicks) / Math.max(1, readCount),
          ),
          urlClickRate2: Math.min(
            1,
            whatsappTemplate?.urlClicks2 / Math.max(1, readCount),
          ),
          clickNode: setSelectedNodeId,
        },
      };
    } else if (dataNode.type === "whatsapp_template") {
      const buttons = nodes.filter(
        (n) => n?.parentNodeId === dataNode.id && n?.type === "reply_button",
      );

      const flowButtons = nodes.filter(
        (n) => n?.parentNodeId === dataNode.id && n?.type === "flow_button",
      );

      const urlButtons = nodes.filter(
        (n) => n?.parentNodeId === dataNode.id && n?.type === "url_button",
      );

      const urlButton = dataNode.whatsappTemplate?.messageSkeleton
        ?.urlButtonText
        ? {
            text: dataNode.whatsappTemplate.messageSkeleton.urlButtonText,
            url:
              dataNode.whatsappTemplate?.redirectionUrl?.url ||
              dataNode.whatsappTemplate.messageSkeleton.urlButtonLink,
            gadgetId:
              dataNode.whatsappTemplate?.redirectionUrl?.flowNode?.id ||
              urlButtons[0]?.id,
            redirectionUrlId: dataNode.whatsappTemplate?.redirectionUrl?.id,
            trackingEnabled: dataNode.whatsappTemplate?.redirectionUrl?.id
              ? true
              : false,
          }
        : null;

      const urlButton2 = dataNode.whatsappTemplate?.messageSkeleton
        ?.urlButtonText2
        ? {
            text: dataNode.whatsappTemplate.messageSkeleton.urlButtonText2,
            url:
              dataNode.whatsappTemplate?.redirectionUrl2?.url ||
              dataNode.whatsappTemplate.messageSkeleton.urlButtonLink2,
            gadgetId:
              dataNode.whatsappTemplate?.redirectionUrl2?.flowNode?.id ||
              urlButtons[1]?.id,
            redirectionUrlId: dataNode.whatsappTemplate?.redirectionUrl2?.id,
            trackingEnabled: dataNode.whatsappTemplate?.redirectionUrl2?.id
              ? true
              : false,
          }
        : null;

      let flowButton = null;
      if (flowButtons?.length > 0) {
        const flowButtonNode = flowButtons[0] || {};
        const { id, flowAction, flowId, navigateScreen, text } =
          flowButtonNode.flowButton;

        flowButton = {
          text,
          gadgetId: flowButtonNode.id,
          id,
          flowId,
          flowAction,
          navigateScreen,
        };

        console.log(`Flow button to integrate ${JSON.stringify(flowButton)}`);
      }

      const updatedCards = dataNode.whatsappTemplate?.cards?.map((card) => {
        return {
          ...card,
          components: card.components.map((component) => {
            if (component.type === "BUTTONS") {
              return {
                ...component,
                buttons: component.buttons.map((button) => {
                  if (button.type === "QUICK_REPLY") {
                    const matchingButton = buttons.find(
                      (b) => b.replyButton.id === button.replyButtonId,
                    );
                    return {
                      ...button,
                      clicks: matchingButton?.replyButton?.clicks || 0,
                      clickRate: Math.min(
                        1,
                        matchingButton?.replyButton?.clicks /
                          Math.max(1, readCount),
                      ),
                    };
                  }
                  if (button.type === "URL") {
                    return {
                      ...button,
                      urlClickRate:
                        Math.min(
                          1,
                          button.urlClicks / Math.max(1, readCount),
                        ) || 0,
                    };
                  }
                  return button;
                }),
              };
            }
            return component;
          }),
        };
      });

      const {
        expirationType,
        expirationDate,
        expirationDelayInMinutes,
        limitedTimeOfferText: text,
        copyCode,
      } = dataNode.whatsappTemplate;
      node = {
        id: nodeCounter.toString(),
        type: "template",
        position: { x: dataNode.positionX, y: dataNode.positionY },
        draggable:
          !dataNode?.whatsappTemplate.messageSkeleton?.isCampaignTrigger,
        deletable:
          !dataNode?.whatsappTemplate.messageSkeleton?.isCampaignTrigger,
        data: {
          nodeId: dataNode.id,
          messageSkeletonId: dataNode.whatsappTemplate.messageSkeleton.id,
          whatsappTemplateId: dataNode.whatsappTemplate.id,
          whatsappTemplateName: dataNode.whatsappTemplate.whatsappTemplateName,
          limitedTimeOffer: expirationType
            ? { expirationDate, expirationDelayInMinutes, expirationType, text }
            : undefined,
          headerParameters: dataNode.whatsappTemplate?.headerParameters
            ? dataNode.whatsappTemplate.headerParameters
            : dataNode.whatsappTemplate?.messageSkeleton?.imageLink
              ? {
                  type: "image",
                  image: {
                    link: dataNode.whatsappTemplate?.messageSkeleton?.imageLink,
                  },
                }
              : dataNode.whatsappTemplate?.messageSkeleton?.videoLink
                ? {
                    type: "video",
                    video: {
                      link: dataNode.whatsappTemplate?.messageSkeleton
                        ?.videoLink,
                    },
                  }
                : null,
          bodyParameters: dataNode.whatsappTemplate.bodyParameters,
          isEditing: dataNode.whatsappTemplate.isEditing,
          isCancelable: dataNode.whatsappTemplate.isCancelable,
          isTemplate:
            dataNode?.whatsappTemplate.messageSkeleton?.isCampaignTrigger ==
            true,
          type:
            dataNode.whatsappTemplate.messageSkeleton.body ||
            dataNode.replyButtons
              ? "text"
              : dataNode.whatsappTemplate.messageSkeleton.imageLink
                ? "image"
                : dataNode.whatsappTemplate.messageSkeleton.videoLink
                  ? "video"
                  : dataNode.whatsappTemplate.messageSkeleton.documentLink
                    ? "document"
                    : dataNode.whatsappTemplate.messageSkeleton.audioLink
                      ? "audio"
                      : dataNode.whatsappTemplate.messageSkeleton.stickerLink
                        ? "sticker"
                        : null,
          body: dataNode.whatsappTemplate.messageSkeleton.body ?? "",
          footer: dataNode.whatsappTemplate.messageSkeleton.footer ?? "",
          video: dataNode.whatsappTemplate.messageSkeleton.videoLink ?? "",
          audio: dataNode.whatsappTemplate.messageSkeleton.audioLink ?? "",
          sticker: dataNode.whatsappTemplate.messageSkeleton.stickerLink ?? "",
          document:
            dataNode.whatsappTemplate.messageSkeleton.documentLink ?? "",
          documentName:
            dataNode.whatsappTemplate.messageSkeleton.documentName ?? "",
          buttons: updatedCards
            ? []
            : buttons.map((b) => ({
                title: b.replyButton.title,
                whatsappId: b.replyButton.whatsappId,
                gadgetId: b.id,
                replyButtonGadgetId: b.replyButton.id,
                clicks: b.replyButton?.clicks,
                clickRate: Math.min(
                  1,
                  b.replyButton?.clicks / Math.max(1, readCount),
                ),
              })),
          copyCodeButton: copyCode ? { text: copyCode } : undefined,
          urlButton,
          urlButton2,
          flowButton,
          isUrlButtonAtBottom:
            dataNode.whatsappTemplate.messageSkeleton.isUrlButtonAtBottom,
          urlClicks: dataNode.whatsappTemplate?.urlClicks,
          urlClicks2: dataNode.whatsappTemplate?.urlClicks2,
          urlClickRate: Math.min(
            1,
            dataNode.whatsappTemplate?.urlClicks / Math.max(1, readCount),
          ),
          urlClickRate2: Math.min(
            1,
            dataNode.whatsappTemplate?.urlClicks2 / Math.max(1, readCount),
          ),
          clickNode: setSelectedNodeId,
          ...(dataNode.whatsappTemplate.messageSkeleton.imageLink ||
          dataNode.whatsappTemplate.messageSkeleton.imageLink === ""
            ? {
                image:
                  dataNode.whatsappTemplate.messageSkeleton.imageLink ?? "",
              }
            : {}),
          cards: updatedCards,
        },
      };
    } else if (dataNode.type === "consent") {
      node = {
        id: nodeCounter.toString(),
        type: "consent",
        position: { x: dataNode.positionX, y: dataNode.positionY },
        data: {
          nodeId: dataNode.id,
          type: dataNode.isOptIn ? "optin" : "optout",
          clickNode: setSelectedNodeId,
        },
      };
    } else if (dataNode.type === "webhook_node") {
      node = {
        id: nodeCounter.toString(),
        type: "webhook",
        position: { x: dataNode.positionX, y: dataNode.positionY },
        data: {
          nodeId: dataNode.id,
          webhookId: dataNode.webhookNode.id ?? "",
          name: dataNode.webhookNode.name ?? "",
          method: dataNode.webhookNode.method ?? "",
          destinationUrl: dataNode.webhookNode.destinationUrl ?? "",
          headers: dataNode.webhookNode.headers ?? [{ key: "", value: "" }],
          queryParams: dataNode.webhookNode.queryParams ?? [
            { key: "", value: "" },
          ],
          pathParams: dataNode.webhookNode.pathParams ?? [
            { key: "", value: "" },
          ],
          configResponse: dataNode.webhookNode.configResponse ?? [
            { key: "", value: "" },
          ],
          body: dataNode.webhookNode.body
            ? JSON.stringify(dataNode.webhookNode.body)
            : `{
          "phone": "{{ contact.userPhoneNumber }}"
          }`,
          clickNode: setSelectedNodeId ?? "",
        },
      };
    } else if (dataNode.type === "waiting_node") {
      node = {
        id: nodeCounter.toString(),
        type: "wait",
        position: { x: dataNode.positionX, y: dataNode.positionY },
        data: {
          nodeId: dataNode.id,
          waitingNodeId: dataNode.waitingNode.id,
          type: dataNode.waitingNode.type ?? "",
          duration: dataNode.waitingNode.durationInMinutes?.toString() ?? "0",
          waitingsCount: dataNode.waitingsCount,
          storeAnswer: dataNode.waitingNode.storeAnswer ?? false,
          storageField: dataNode.waitingNode.storageField ?? "",
          clickNode: setSelectedNodeId,
        },
      };
    } else if (dataNode.type === "tag") {
      node = {
        id: nodeCounter.toString(),
        type: "tag",
        position: { x: dataNode.positionX, y: dataNode.positionY },
        data: {
          nodeId: dataNode.id,
          tagId: dataNode?.tag?.id,
          tag: dataNode?.tag?.name,
          clickNode: setSelectedNodeId,
        },
      };
    } else if (dataNode.type === "ai") {
      const { user } = useContext(CustomerContext);
      node = {
        id: nodeCounter.toString(),
        type: "ai",
        position: { x: dataNode.positionX, y: dataNode.positionY },
        data: {
          nodeId: dataNode.id,
          aiConfigurationId: dataNode?.aiConfiguration?.id,
          answerStyle: dataNode?.aiConfiguration?.answerStyle,
          assistantContext: dataNode?.aiConfiguration?.assistantContext,
          companyContext: dataNode?.aiConfiguration?.companyContext,
          gaiaWebsiteDatasources: user.customer.gaiaWebsiteDatasources || [
            { id: null, url: "" },
          ],
          clickNode: setSelectedNodeId,
        },
      };
    } else if (dataNode.type === "automation_trigger") {
      node = {
        id: nodeCounter.toString(),
        type: "automationTrigger",
        position: { x: dataNode.positionX, y: dataNode.positionY },
        deletable: false,
        draggable: false,
        data: {
          nodeId: dataNode.id,
          clickNode: setSelectedNodeId,
          type: dataNode.automationTriggerType,
          abandonedCartDelayInMinutes: dataNode.abandonedCartDelayInMinutes,
        },
      };
    } else if (dataNode.type === "note") {
      node = {
        id: nodeCounter.toString(),
        type: "note",
        position: { x: dataNode.positionX, y: dataNode.positionY },
        data: {
          nodeId: dataNode.id,
          clickNode: setSelectedNodeId,
          note: dataNode.note,
        },
      };
    } else if (dataNode.type === "condition") {
      node = {
        id: nodeCounter.toString(),
        type: "condition",
        position: { x: dataNode.positionX, y: dataNode.positionY },
        data: {
          nodeId: dataNode.id,
          conditionId: dataNode.condition.id,
          operator: dataNode.condition.operator,
          property: dataNode.condition.property,
          valuePercentage: dataNode.condition.valuePercentage,
          valueBoolean: dataNode.condition.valueBoolean,
          valueStartingPeriodInMinutes:
            dataNode.condition.valueStartingPeriodInMinutes,
          valueType: dataNode.condition.valueType,
          valueTag: {
            id: dataNode.condition.valueTag?.id,
            name: dataNode.condition.valueTag?.name,
          },
          clickNode: setSelectedNodeId,
          trueCount: dataNode.condition.conditionTrueCount,
          falseCount: dataNode.condition.conditionFalseCount,
        },
      };
    } else {
      // Other
      continue;
    }

    initialNodes.push(node);

    nodeCounter++;
  }

  const handleIds = [..."abcdefghijklmnopqrstuvwxyz"];

  for (let k = 0; k < edges?.length; k++) {
    try {
      const dataEdge = edges[k];
      var sourceNode = initialNodes.find(
        (n) => n.data?.nodeId === dataEdge.sourceNode?.id,
      );
      var sourceHandle = "main";
      if (!sourceNode) {
        const buttonNode = nodes.find((n) => n.id === dataEdge.sourceNode?.id);
        if (buttonNode) {
          sourceNode = initialNodes.find(
            (n) => n.data?.nodeId === buttonNode.parentNodeId,
          );
          if (sourceNode?.data?.cards) {
            let foundGlobalIndex = -1;
            if (Array.isArray(sourceNode?.data?.cards)) {
              for (
                let cardIdx = 0;
                cardIdx < sourceNode.data.cards.length;
                cardIdx++
              ) {
                const card = sourceNode.data.cards[cardIdx];
                const buttonsComponent = card.components.find(
                  (c) => c.type === "BUTTONS",
                );
                if (
                  buttonsComponent &&
                  Array.isArray(buttonsComponent.buttons)
                ) {
                  const btnIdx = buttonsComponent.buttons.findIndex(
                    (b) => b.gadgetId === buttonNode.id,
                  );
                  if (btnIdx !== -1) {
                    foundGlobalIndex = cardIdx * 2 + btnIdx;
                    break;
                  }
                }
              }
            }

            sourceHandle = handleIds[foundGlobalIndex] || "main";
          } else if (buttonNode.type === "url_button") {
            if (
              sourceNode?.data?.urlButton &&
              dataEdge.sourceNode?.id === sourceNode.data.urlButton.gadgetId
            ) {
              sourceHandle = "urlA";
            }

            if (
              sourceNode?.data?.urlButton2 &&
              dataEdge.sourceNode?.id === sourceNode.data.urlButton2.gadgetId
            ) {
              sourceHandle = "urlB";
            }
          } else if (buttonNode.type === "flow_button") {
            console.log(
              `[LoadEdge] flow_button edge - buttonNode.id: ${buttonNode.id}, dataEdge.sourceNode.id: ${dataEdge.sourceNode?.id}, sourceNode.data.flowButton.gadgetId: ${sourceNode?.data?.flowButton?.gadgetId}`,
            );
            if (
              sourceNode?.data?.flowButton &&
              dataEdge.sourceNode?.id === sourceNode.data.flowButton.gadgetId
            ) {
              sourceHandle = "flowButton";
              console.log(
                `[LoadEdge] Matched! Setting sourceHandle to flowButton`,
              );
            } else {
              console.log(
                `[LoadEdge] NOT matched! sourceHandle will be: ${sourceHandle}`,
              );
            }
          } else {
            const sourceHandleIndex = sourceNode.data.buttons.findIndex(
              (b) => b.gadgetId === buttonNode.id,
            );
            sourceHandle = handleIds[sourceHandleIndex];
          }
        }
      }

      if (sourceNode?.type === "condition") {
        sourceHandle = dataEdge.isSourceTrueCondition ? "true" : "false";
      }

      var sourceId = sourceNode?.id;

      const targetId = initialNodes.find(
        (n) => n.data?.nodeId === dataEdge.targetNode?.id,
      )?.id;
      const edge = {
        type: "customedge",
        id: sourceId + sourceHandle + "->" + targetId,
        source: sourceId,
        sourceHandle: sourceHandle,
        target: targetId,
        data: {
          edgeId: dataEdge.id,
        },
      };

      initialEdges.push(edge);
    } catch (e) {
      console.error(`Error adding edge: ${e}`);
    }
  }
  return [initialNodes, initialEdges];
}
